import { IRequestService } from "../../service/request/RequestService";

export default class GetApplicantRequestsInteractor {
  private requestService: IRequestService;

  constructor(requestService) {
    this.requestService = requestService;
  }

  async execute(reportingPeriodApplicantId: number) {
    return this.requestService.getApplicantRequests(reportingPeriodApplicantId);
  }
}
